import {V3BadgeTypeType} from '@wix/ambassador-events-v3-event/types'
import {useStyles} from '@wix/tpa-settings/react'
import {ExperimentNames, LIST_LAYOUT, MOBILE_WIDGET_LAYOUT} from '@wix/wix-events-commons-statics'
import {useEnvironment, useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import stylesParams from '../../../stylesParams'
import {useWidgetState} from '../../hooks/state-provider'
import {getEventBadge} from '../../selectors/events'
import {BadgeType, EVENT_BADGE_TYPE} from '../../utils/event-badges'
import s from './event-badge.scss'
import {EventBadgeProps} from './interfaces'

export const EventBadge = ({event, onImage, className}: EventBadgeProps) => {
  const {isMobile} = useEnvironment()
  const {get} = useStyles()
  const {t} = useTranslation()
  const {experiments} = useExperiments()

  const calendarRevampEnabled = experiments.enabled(ExperimentNames.CalendarRevamp)
  const eventBadge = useWidgetState(state => getEventBadge(state, event))
  const calendarLayout = isMobile
    ? get(stylesParams.mobileWidgetLayoutNew) === MOBILE_WIDGET_LAYOUT.CALENDAR
    : get(stylesParams.listLayout) === LIST_LAYOUT.CALENDAR
  const calendar = calendarLayout && calendarRevampEnabled
  const fullWidth = calendar ? get(stylesParams.calendarEventBadgeStretched) : get(stylesParams.eventBadgeStretched)

  const firstPriority =
    (eventBadge?.type as BadgeType) === EVENT_BADGE_TYPE.FIRST_PRIORITY ||
    eventBadge?.type === V3BadgeTypeType.FIRST_PRIORITY

  const secondPriority =
    (eventBadge?.type as BadgeType) === EVENT_BADGE_TYPE.SECOND_PRIORITY ||
    eventBadge?.type === V3BadgeTypeType.SECOND_PRIORITY

  const thirdPriority =
    (eventBadge?.type as BadgeType) === EVENT_BADGE_TYPE.THIRD_PRIORITY ||
    eventBadge?.type === V3BadgeTypeType.THIRD_PRIORITY

  const onImageClass = calendarRevampEnabled ? s.onImage : s.onImageOld
  const eventInfoClass = calendarRevampEnabled ? s.eventInfo : s.eventInfoOld

  return eventBadge ? (
    <div
      className={classNames(className, onImage ? onImageClass : eventInfoClass, {
        [s.container]: onImage,
        [s.calendarRevamp]: calendarRevampEnabled,
        [s.first]: firstPriority,
        [s.second]: secondPriority,
        [s.third]: thirdPriority,
      })}
    >
      <div
        data-hook="event-badge"
        className={classNames(s.badge, calendar ? s.calendarBadgeStyle : s.badgeStyle, {
          [s.first]: firstPriority,
          [s.second]: secondPriority,
          [s.third]: thirdPriority,
          [s.fullWidth]: onImage && fullWidth,
        })}
      >
        <div
          className={classNames(calendar ? s.calendarText : s.text, {
            [s.first]: firstPriority,
            [s.second]: secondPriority,
            [s.third]: thirdPriority,
          })}
        >
          {eventBadge.text ?? t('defaultEventBadge')}
        </div>
      </div>
    </div>
  ) : null
}
